import React from 'react';
import { View } from 'react-native';
import Svg, { Line as SvgLine } from 'react-native-svg';

type Props = Record<string, any>;

const Line: React.FC<Props> = (props) => {
  const borderStyle = props?.attributes?.borderStyle || props.borderStyle;
  const color = props?.attributes?.backgroundColor || props.backgroundColor;
  const width = props.width;
  const height = props.height;

  if (!borderStyle || borderStyle === 'none') {
    return <View style={{ width, height }} />;
  }

  const strokeWidth = height;
  const y = height / 2;

  let strokeDasharray: string | undefined;
  if (borderStyle === 'dotted') {
    strokeDasharray = `0 ${strokeWidth * 2}`;
  } else if (borderStyle === 'dashed') {
    strokeDasharray = `${strokeWidth} ${strokeWidth * 2}`;
  }

  return (
    <Svg width={width} height={height}>
      <SvgLine
        x1={0}
        y1={y}
        x2={width}
        y2={y}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={strokeDasharray}
        strokeLinecap={borderStyle === 'dotted' ? 'round' : 'square'}
      />
    </Svg>
  );
};

export default Line;
